import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import AcceptedUnprocessedIssuesModal from './AcceptedUnprocessedIssuesModal';
import { ClipLoader } from 'react-spinners';

export default function AcceptedUnprocessedIssues({
  increaseFormStep,
  setFormInfo,
}) {
  const [acceptedUnprocessedIssues, setAcceptedUnprocessedIssues] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const apiUrl = process.env.REACT_APP_BACKEND_API;

  const fetchAcceptedUnprocessedIssues = async () => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${apiUrl}/issues/accepted/unprocessed`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    return response.json();
  };

  const { data } = useQuery(
    ['acceptedUnprocessedIssues'],
    fetchAcceptedUnprocessedIssues,
    {
      onSuccess: (response) => {
        setAcceptedUnprocessedIssues(response);
        setIsLoading(false);
      },
      onError: (error) => {
        console.error(error);
        setIsLoading(false);
      },
    }
  );

  return (
    <div>
      <div className="accepted-unprocessed-reports-body">
        {acceptedUnprocessedIssues &&
          acceptedUnprocessedIssues.length > 0 &&
          acceptedUnprocessedIssues.map((acceptedUnprocessedIssue, index) => (
            <AcceptedUnprocessedIssuesModal
              key={acceptedUnprocessedIssue.code}
              acceptedUnprocessedIssue={acceptedUnprocessedIssue}
              increaseFormStep={increaseFormStep}
              setFormInfo={setFormInfo}
              index
            />
          ))}

        {acceptedUnprocessedIssues &&
          acceptedUnprocessedIssues.length === 0 && (
            <div className="accepted-unprocessed-report-empty">
              Sve prihvaćene prijave su obrađene.
            </div>
          )}

        {isLoading && (
          <div className="accepted-unprocessed-report-spinner">
            <ClipLoader
              color={'gray'}
              loading={true}
              size={40}
              data-testid="loader"
            />
          </div>
        )}
      </div>
    </div>
  );
}
